import React from "react";
import PropTypes from "prop-types";
import { Button, HStack, Text } from "rsuite";
import WavePointIcon from "@rsuite/icons/WavePoint";
import { getAuth, signOut } from "firebase/auth";
import { useGlobalPersistentStore } from "../../store";
import "./Brand.css";

const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "";
const BRAND_SUB_NAME = process.env.REACT_APP_BRAND_SUB_NAME || "";

const Brand = ({ expand = false }) => {
  const { loggedInUserDetails, setLoggedInUserDetails, setBrokerLoginDetails } =
    useGlobalPersistentStore();

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        setLoggedInUserDetails({ username: "" });
        setBrokerLoginDetails({ clientCode: "", dhanApiKey: "" });
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  };

  return (
    <div className="page-brand-container">
      <HStack spacing={20}>
        <div className="brand-logo">
          <WavePointIcon />
        </div>
        {expand && (
          <div className="brand-text-container">
            <Text className="brand-text-main">{BRAND_NAME}</Text>
            <Text className="brand-text-sub">{BRAND_SUB_NAME}</Text>
          </div>
        )}
      </HStack>
      <HStack style={{ height: 40 }} spacing={50}>
        {loggedInUserDetails?.username && (
          <Button
            appearance="primary"
            className="login-button-name"
            onClick={handleLogout}
          >
            Logout
          </Button>
        )}
      </HStack>
    </div>
  );
};

Brand.propTypes = {
  expand: PropTypes.bool,
};

export default React.memo(Brand);
